import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { View, Animated, Platform } from 'react-native';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
import { AnimatedTextView } from '../Typography/AnimatedTextView';
import { HTMLView } from '../Common/HTMLView';
import { AnimatedPressable } from '../Buttons/AnimatedPressable';
import { useAnimation } from '../Animations/AnimationHooks';
import { objectToStyle } from '../../../Helpers/HTML/HTMLParser';
export const ChoiceItemSelectView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.choiceItemSelect,
    style(theme, mediaQuery, window, props) {
        var _a, _b, _c, _d;
        return {
            container: {
                opacity: props.disabled ? 0.4 : 1,
                flexDirection: 'row',
                alignItems: 'center'
            },
            title: Object.assign({ fontSize: 16 }, Platform.select({
                ios: {
                    marginBottom: 6
                }
            })),
            circle: {
                borderRadius: 10,
                width: 20,
                height: 20,
                borderWidth: 2,
                borderColor: ((_a = theme.colors) === null || _a === void 0 ? void 0 : _a.link_color) || 'rgba(99, 120, 143, 1)',
                padding: 2
            },
            activeCircle: {
                borderColor: ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.secondary_color) || 'rgba(17, 85, 204, 1)'
            },
            innerCircle: {
                borderRadius: 8,
                flex: 1,
                backgroundColor: ((_c = props.customize) === null || _c === void 0 ? void 0 : _c.color) || ((_d = theme.colors) === null || _d === void 0 ? void 0 : _d.secondary_color) || 'rgb(17, 85, 204)',
            },
            content: {
                flex: 1,
                paddingStart: 15
            },
            description: {
                fontSize: 12,
                lineHeight: 16
            },
            caption: {
                fontSize: 12,
                lineHeight: 16
            }
        };
    }
})(({ style, value, onChange, id, testID, title, description, display_price, disabled, light }) => {
    var _a, _b;
    const [borderColor, setBorderColor] = useAnimation({ initialValue: value ? 1 : 0, duration: 200, nativeDriver: false });
    const [opacity, setOpacity] = useAnimation({ initialValue: value ? 1 : 0, duration: 200, nativeDriver: Platform.OS !== 'web' });
    useEffect(() => {
        setBorderColor(value ? 1 : 0);
        setOpacity(value ? 1 : 0);
    }, [value]);
    const handleChange = useCallback(() => {
        if (disabled) {
            return;
        }
        const updatedValue = value === 0
            ? 1
            : 0;
        typeof onChange === 'function' && onChange(id, updatedValue);
    }, [value, onChange]);
    const handleMouseOver = useCallback(() => {
        if (disabled) {
            return;
        }
        setBorderColor(1);
    }, [value]);
    const handleMouseLeave = useCallback(() => {
        if (disabled) {
            return;
        }
        !value && setBorderColor(0);
    }, [value]);
    const color = borderColor.interpolate({
        inputRange: [0, 1],
        outputRange: [(_a = style === null || style === void 0 ? void 0 : style.circle) === null || _a === void 0 ? void 0 : _a.borderColor, (_b = style === null || style === void 0 ? void 0 : style.activeCircle) === null || _b === void 0 ? void 0 : _b.borderColor]
    });
    const Button = AnimatedPressable;
    return (_jsxs(Button, { testID: `choice-item-${testID || title || ''}`, style: style === null || style === void 0 ? void 0 : style.container, onPress: handleChange, onMouseOver: handleMouseOver, onMouseLeave: handleMouseLeave, children: [_jsx(AnimatedTextView, { children: _jsx(Animated.View, { style: [style === null || style === void 0 ? void 0 : style.circle, { borderColor: color }], children: _jsx(Animated.View, { style: [style === null || style === void 0 ? void 0 : style.innerCircle, { opacity }] }) }) }), _jsxs(View, { style: style === null || style === void 0 ? void 0 : style.content, children: [!!title && (_jsx(AnimatedTextView, { textStyle: style === null || style === void 0 ? void 0 : style.title, light: light, children: title })), !!description && (_jsx(HTMLView, { value: `<small style="${objectToStyle(style === null || style === void 0 ? void 0 : style.description)} ${light ? 'light' : ''}>${description}</small>` })), !!display_price && (_jsx(AnimatedTextView, { textStyle: style === null || style === void 0 ? void 0 : style.caption, light: light, children: display_price }))] })] }));
});
